module.exports = __webpack_public_path__ + "img/btn-others.85da33cf.png";